import { BaseBadgeProps } from "./types";

import "./styles.css";

const BaseBadge = ({
  leadingIcon,
  trailingIcon,
  children,
  borderColor,
  backgroundColor,
  fontColor,
  className,
}: BaseBadgeProps) => {
  return (
    <div
      className={`base-badge body-s-regular ${className}`}
      style={{
        border: `1px solid ${borderColor}`,
        backgroundColor: `${backgroundColor}`,
        color: fontColor,
      }}
    >
      {leadingIcon && <span>{leadingIcon}</span>}

      {children}

      {trailingIcon && <span>{trailingIcon}</span>}
    </div>
  );
};

export default BaseBadge;
